module.exports = __webpack_public_path__ + "img/ethereum.dadd7445.svg";